import { contents } from "@/mocks/contents";
import ContentCard from "@/components/feature/ContentCard";

export default function PopularGrid() {
  const popular = [...contents].sort((a, b) => b.views - a.views).slice(0, 10);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
      {popular.map((item, i) => (
        <ContentCard key={item.id} item={item} index={i} />
      ))}
    </div>
  );
}